<template>
    <div :id="idName" :class="' ' + className">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: {
            className: {
                default: "",
                type: String,
            },
            idName: {
                default: "",
                type: String,
            }
        },
    }
</script>